import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------credit api's-------------------------------->
    /**
     * get tax index page
     * @param {} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getCurrencyList(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/currency/index')
    },
    createCurrency(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/create', data)

    },
    getCurrencyDetails(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/currency/view/' + id)
    },
    updateCurrency(id, data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/update/' + id, data)
    },
    exchangeRateStatusChange(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/statuschange/', data)

    },
    getExRateExport(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/currency/export')
    },
    deletecurrency(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/singledelete/', data)
    },
    deleteExchangeRate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/exchangeratedelete/', data)
    },
    getExRateList(id, sort, label, token) {
        var filter = '?sort=' + sort + '&label=' + label;
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/currency/viewpage/' + id + '/' + filter)
    },
    addExchangeRate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/exchangeratecreate', data)
    },
    importExchangeRateValidation(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/importvalidation', data)
    },
    importExchangeRate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/import', data)
    },
    getExchangeRate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/currency/exchangeratedetailsview', data)
    },

}